module.exports = __webpack_public_path__ + "static/img/R.6535161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lll/R.png
// module id = 8PmN
// module chunks = 0